"use client";

import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
} from "@mui/material";
import { WarningAmber, Refresh } from "@mui/icons-material";

interface ConcurrencyDialogProps {
  open: boolean;
  onDismiss: () => void;
  onRefresh: () => void;
  message?: string;
}

export const ConcurrencyDialog: React.FC<ConcurrencyDialogProps> = ({
  open,
  onDismiss,
  onRefresh,
  message,
}) => {
  const defaultMessage =
    "This Work Order has been updated by another user. Please refresh to get the latest changes.";

  return (
    <Dialog
      open={open}
      onClose={onDismiss}
      aria-labelledby="concurrency-dialog-title"
      aria-describedby="concurrency-dialog-description"
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle
        id="concurrency-dialog-title"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          backgroundColor: "red",
          color: "warning.contrastText",
        }}
      >
        <WarningAmber sx={{ color: "" }} />
        <Box component="span" sx={{ color: "", fontWeight: 600 }}>
          Work Order Updated
        </Box>
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <DialogContentText id="concurrency-dialog-description">
          {message || defaultMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onDismiss}
          variant="outlined"
          color="inherit"
          sx={{
            textTransform: "capitalize",
          }}
        >
          Dismiss
        </Button>
        <Button
          sx={{
            textTransform: "capitalize",
          }}
          onClick={onRefresh}
          variant="contained"
          color="primary"
          startIcon={<Refresh />}
          autoFocus
        >
          Refresh
        </Button>
      </DialogActions>
    </Dialog>
  );
};
